import React, { useContext } from 'react';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import Loading from "./Loading";
import AppContext from "../../../contexts/AppContext";

let IndivyPlanLandingHeader = () => {
    return (
        <div className="col-12 px-0">
            <div className="alert mb-0 pb-2">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-1 offset-xl-2">
                        <p>
                            Prašome užpildyti žemiau pateiktus laukelius, kad galėtume Jums suformuoti asmeninį vartojimo paskolos pasiūlymą, skirtą mokėti dalimis.
                        </p>
                        <p>
                            Atkreipkite dėmesį, kad pasirinkus naują mokėjimo būdą, bus taikomi papildomi mokesčiai bei pasirašoma vartojimo paskolos sutartis. Jei pateiktas mokėjimo dalimis pasiūlymas Jums bus nepriimtinas, galėsite jo atsisakyti ir likti prie pirminio „Indivy“ mokėjimo termino.
                        </p>
                        <p>
                            Jei turite klausimų, susisiekite su mumis telefonu <a href="tel:+37070070080">+370 700 70080</a> arba el. paštu <a href="mailto:info@inbank.lt">info@inbank.lt</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

let IndivyPlanHeader = ({ suggestion: { eshop_data } }) => {
    return (
        <>
            {!_.isEmpty(eshop_data) &&
                <div className="wrapper wrapper--1-3 px-4 py-5 justify-content-between mt-2 second-header">
                    <div className="col-12 col-lg-6 mt-4 mt-lg-0 wrapper__wrap">
                        <h3 className="wrapper__wrap-heading">Užsakymo numeris<br />
                            <span className="wrapper__wrap-heading--highlight text-primary">
                                {eshop_data.order_id}
                            </span>
                        </h3>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0 wrapper__wrap">
                        <h3 className="wrapper__wrap-heading">Užsakymo suma<br />
                            <span className="wrapper__wrap-heading--highlight text-primary">
                                <NumberFormat
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    displayType={"text"}
                                    value={eshop_data.order_amount}
                                /> €
                            </span>
                        </h3>
                    </div>
                </div>
            }
        </>
    );
}


function SecondHeader(props) {
    let { type, loading, eshop_data } = props.suggestion,
        { processStep } = useContext(AppContext),
        isLoading = loading && !eshop_data.order_id,
        isIndivyPlan = type === 'IP';

    return (
        <div className="w-100">
            {isLoading ?
                <div className="wrapper wrapper--1-3 px-4 py-2 mt-4 justify-content-between second-header">
                    <div className="col-12 wrapper__wrap">
                        <Loading small={true}/>
                    </div>
                </div>
                :
                <div className="w-100">
                    {!isIndivyPlan
                        ? <>
                            {props.suggestion.is_eshop ?
                                <div className="wrapper wrapper--1-3 px-4 py-5 justify-content-between mt-2 second-header">
                                    <div className="col-12 col-lg-4 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">
                                            <span className="wrapper__wrap-heading--highlight text-primary">
                                                <a href={props.suggestion.eshop_data.return_url}>Grįžti pas pardavėją</a>
                                            </span>
                                        </h3>
                                    </div>

                                    <div className="col-12 col-lg-4 mt-4 mt-lg-0 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">Užsakymo numeris<br />
                                            <span className="wrapper__wrap-heading--highlight text-primary">
                                                {props.suggestion.eshop_data.order_id}
                                            </span>
                                        </h3>
                                    </div>

                                    <div className="col-12 col-lg-4 mt-4 mt-lg-0 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">Užsakymo suma<br />
                                            <span className="wrapper__wrap-heading--highlight text-primary">
                                                {props.suggestion.eshop_data.order_amount} {props.suggestion.eshop_data.order_cur}
                                            </span>
                                        </h3>
                                    </div>
                                </div>
                                :
                                <div className="wrapper wrapper--1-3 px-4 py-5 justify-content-between mt-2 second-header">
                                    <div className="col-12 col-lg-4 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">{props.t('chosen_amount')}<br/>
                                            <span className="wrapper__wrap-heading--highlight text-primary">
                                                {props.suggestion.amount} {props.t('currency')}
                                            </span>
                                        </h3>
                                    </div>
                                    <div className="col-12 col-lg-4 mt-4 mt-lg-0 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">{props.t('chosen_type')}<br/><span
                                            className="wrapper__wrap-heading--highlight text-primary">{props.t('products.' + props.suggestion.type)}</span>
                                        </h3>
                                    </div>
                                    <div className="col-12 col-lg-4 mt-4 mt-lg-0 wrapper__wrap">
                                        <h3 className="wrapper__wrap-heading">{props.t('chosen_term')}<br/><span
                                            className="wrapper__wrap-heading--highlight text-primary">{props.suggestion.term} {props.t('month')}</span>
                                        </h3>
                                    </div>
                                </div>
                            }
                        </>
                        : <>
                            {processStep === 'contacts'
                                ? <IndivyPlanLandingHeader />
                                : <IndivyPlanHeader {...props} />
                            }
                        </>
                    }
                </div>
            }
        </div>
    );
}

export default withTranslation()(SecondHeader);
